// js/custom-element/section/multi-column/multi-column.js
(function() {
  const init = function() {
    if (!window.customElements.get("multi-column")) {
      var MultiColumn = class extends CustomHTMLElement {
        connectedCallback() {
          this._setupScrolling();
          if (this.hasAttribute("stagger-apparition")) {
            this._setupVisibility();
          }
        }
        
        _setupScrolling() {
          // Check if we should enable scrolling based on device and stack settings
          const isMobile = window.innerWidth <= 999;
          const shouldEnableScrolling = isMobile ? !this.hasAttribute("stack-mobile") : !this.hasAttribute("stack-desktop");
          
          if (shouldEnableScrolling) {
            this.multiColumnInner = this.querySelector(".multi-column__inner");
            this.addEventListener("prev-next:prev", this.previous.bind(this));
            this.addEventListener("prev-next:next", this.next.bind(this));
            if (Shopify.designMode) {
              this.addEventListener("shopify:block:select", (event) => {
                event.target.scrollIntoView({ inline: "center", block: "nearest", behavior: event.detail.load ? "auto" : "smooth" });
              });
            }
          }
          
          // Add resize listener to handle orientation changes
          this._resizeHandler = this._handleResize.bind(this);
          window.addEventListener('resize', this._resizeHandler);
        }
        
        _handleResize() {
          // Debounce resize events
          clearTimeout(this._resizeTimeout);
          this._resizeTimeout = setTimeout(() => {
            this._setupScrolling();
          }, 250);
        }
        
        disconnectedCallback() {
          // Clean up event listeners
          if (this._resizeHandler) {
            window.removeEventListener('resize', this._resizeHandler);
          }
          if (this._resizeTimeout) {
            clearTimeout(this._resizeTimeout);
          }
        }
        async _setupVisibility() {
          await this.untilVisible({ threshold: Math.min(50 / this.clientHeight, 1) });
          const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
          const animation = new window.CustomAnimation(new window.ParallelEffect(Array.from(this.querySelectorAll(".multi-column__item")).map((item, index) => {
            return new window.CustomKeyframeEffect(item, {
              opacity: [0, 1],
              transform: [`translateY(${window.matchMedia("(prefers-reduced-motion: reduce)").matches ? 0 : window.innerWidth < 1e3 ? 35 : 60}px)`, "translateY(0)"]
            }, {
              duration: 600,
              delay: prefersReducedMotion ? 0 : 100 * index,
              easing: "ease"
            });
          })));
          this._hasSectionReloaded ? animation.finish() : animation.play();
        }
        previous(event) {
          const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1, columnGap = parseInt(getComputedStyle(this).getPropertyValue("--multi-column-column-gap"));
          event.target.nextElementSibling.removeAttribute("disabled");
          event.target.toggleAttribute("disabled", this.multiColumnInner.scrollLeft * directionFlip - (this.multiColumnInner.clientWidth + columnGap) <= 0);
          this.multiColumnInner.scrollBy({ left: -(this.multiColumnInner.clientWidth + columnGap) * directionFlip, behavior: "smooth" });
        }
        next(event) {
          const directionFlip = window.themeVariables.settings.direction === "ltr" ? 1 : -1, columnGap = parseInt(getComputedStyle(this).getPropertyValue("--multi-column-column-gap"));
          event.target.previousElementSibling.removeAttribute("disabled");
          event.target.toggleAttribute("disabled", this.multiColumnInner.scrollLeft * directionFlip + (this.multiColumnInner.clientWidth + columnGap) * 2 >= this.multiColumnInner.scrollWidth);
          this.multiColumnInner.scrollBy({ left: (this.multiColumnInner.clientWidth + columnGap) * directionFlip, behavior: "smooth" });
        }
      };
      window.customElements.define("multi-column", MultiColumn);
    }
  }
  if (window.criticalLoaded) { init() }
  else { document.addEventListener("critical-js:loaded", init); }
})();